import { ValueOf } from 'global';
import { DeskingEquipmentFormPart } from './types';

export const listOfEquipmentDeskingFormFieldsDependOnEntity: (keyof ValueOf<
  Pick<DeskingEquipmentFormPart, 'equipment'>,
  'equipment'
>)[] = [
  'year',
  'make',
  'model',
  'class',
  'stockId',
  'newUsed',
  'quantity',
  'description',
  'retailPrice',
  'serialNumberVin',
  'totalWholesaleCost',
];
